import RBush from 'rbush';
import { useMemo } from 'react';

import { useMapContext } from 'shared/context/MapContext';
import { useConstant } from 'shared/hooks/useConstant';
import { RBushItem } from 'shared/types/Map';

type UseInitPinsLayerResult = {
  pinsLayer: YMaps.PinsLayer;
  rbush: RBush<RBushItem>;
};

export function useInitPinsLayer(): UseInitPinsLayerResult {
  const { ymaps, map } = useMapContext();
  const rbush = useConstant(() => new RBush<RBushItem>());
  const pinsLayer = useConstant(() => new ymaps.PinsLayer({ map, rbush }));

  return useMemo(() => ({ pinsLayer, rbush }), [pinsLayer, rbush]);
}
